import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useLookups } from "@/context/LookupContext";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const { setLookups } = useLookups();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("aurelia_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        // Load lookups after authentication
        return api.get("/lookups");
      })
      .then((r) => { if (r) setLookups(r.data); })
      .catch(() => { localStorage.removeItem("aurelia_token"); })
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const login = async (phone, password) => {
    const { data } = await api.post("/auth/login", { phone, password });
    localStorage.setItem("aurelia_token", data.token);
    setUser(data.user);
    // Load lookups after login
    try {
      const r = await api.get("/lookups");
      setLookups(r.data);
    } catch { /* ignore */ }
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("aurelia_token", data.token);
    setUser(data.user);
    // Load lookups after registration
    try {
      const r = await api.get("/lookups");
      setLookups(r.data);
    } catch { /* ignore */ }
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("aurelia_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
